/**
 * Prenatals Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import {store} from "../../store";

// States
const state = {
    prenatalConsultPhysicalExams: [],
    prenatalConsultComplementaryExams: [],
    prenatalConsultations: [],
    prenatalConsultation: {}
};

// Getters
const getters = {
    prenatalConsultations: state => {
        return state.prenatalConsultations
    },

    prenatalConsultation: state => {
        return state.prenatalConsultation
    },

    prenatalConsultPhysicalExams: state => {
        return state.prenatalConsultation.examens_clinique
    },
    prenatalConsultComplementaryExams: state => {
        return state.prenatalConsultation.examens_complementaire
    },
};

// Actions
const actions = {
    getPrenatalConsultations(context, payload) {
        function successCallback(response) {
            context.commit('getPrenatalConsultationsHandler', { prenatalConsultations: response.data.consultationsPrenatale });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.Prenatal.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getPrenatalConsultation(context, payload) {
        function successCallback(response) {
            context.commit('getPrenatalConsultationHandler', { prenatalConsultation: response.data.consultationPrenatale });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.Prenatal.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createPrenatalConsultation(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            router.push({ name: 'consultation-prenatal', params: { consultation: response.data.consultationPrenatale.slug } });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.Prenatal.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updatePrenatalConsultation(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            store.dispatch('findAndRemove', {name: 'consultation-prenatal' });

            router.push({ name: 'consultation-prenatal', params: { consultation: response.data.consultationPrenatale.slug } });
            }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.Prenatal.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deletePrenatalConsultation(context, payload) {
        function successCallback(response) {
            context.commit('deletePrenatalHandler', { index: payload.index, successMessage: payload.successMessage });
            router.push({ name: 'consultations-prenatals-per-obstetric',params:{ consultation:response.data.consultationPrenatale.consultation_obstetrique.slug} });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.Prenatal.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    archievePrenatalConsultation(context, payload) {
        function successCallback(response) {
            context.commit('archievePrenatalConsultationHandler', { index: payload.index, successMessage: payload.successMessage });

            router.push({ name: 'consultation-prenatal', params: { consultation: response.data.resultat.slug } });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.Prenatal.Archieve, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    transmitPrenatalConsultation(context, payload) {
        function successCallback(response) {
            context.commit('transmitPrenatalConsultationHandler', { index: payload.index, successMessage: payload.successMessage });

            router.push({ name: 'consultation-prenatal', params: { consultation: response.data.resultat.slug } });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.Prenatal.Transmit, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deletePrenatalConsultationPhysicalExam(context, payload) {
        function successCallback(response) {
            state.prenatalConsultPhysicalExams = state.prenatalConsultation.examens_clinique;
            context.commit('deletePrenatalConsultationPhysicalExamHandler', { index: payload.index, successMessage: payload.successMessage, response:response });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.Prenatal.RemovePhysicalExams, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    addPrenatalConsultationPhysicalExam(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            router.push({ name: 'prenatal-consultation-physicals-examinations', params:{consultation:response.data.consultation.slug} });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.Prenatal.AddPhysicalExams, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    deletePrenatalConsultationComplementarieExam(context, payload) {
        function successCallback(response) {
            state.prenatalConsultComplementarieExams = state.prenatalConsultation.examens_complementaire;
            context.commit('deletePrenatalConsultationComplementarieExamHandler', { index: payload.index, successMessage: payload.successMessage, response:response });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.Prenatal.RemoveComplementaryExams, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    addPrenatalConsultationComplementarieExam(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            router.push({ name: 'prenatal-consultation-complementaries-examinations', params:{consultation:response.data.consultation.slug} });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.Prenatal.AddComplementaryExams, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

// Mutations
const mutations = {

    getPrenatalConsultationsHandler(state, { prenatalConsultations }) {
        // Update prenatalConsultations state
        state.prenatalConsultations = prenatalConsultations;
    },

    getPrenatalConsultationHandler(state, { prenatalConsultation }) {
        // Update prenatalConsultation state
        state.prenatalConsultation = prenatalConsultation;
    },

    deletePrenatalHandler(state, { index, successMessage }) {
        let i = state.prenatalConsultations.findIndex(prenatalConsultation => prenatalConsultation.slug === index);

        if (~i) {
            state.prenatalConsultations.splice(i, 1);

            Vue.swal(
                successMessage,
                '',
                'success'
            );
        }
    },

    archievePrenatalConsultationHandler(state, { index, successMessage }) {
        router.push({ name: 'consultations-prenatals' });

        Vue.swal(
            successMessage,
            '',
            'success'
        );
    },

    transmitPrenatalConsultationHandler(state, { index, successMessage }) {
        router.push({ name: 'consultations-prenatals' });

        Vue.swal(
            successMessage,
            '',
            'success'
        );
    },

    deletePrenatalConsultationPhysicalExamHandler(state, { index, successMessage,response }) {

        let i = state.prenatalConsultPhysicalExams.findIndex(physicalExam => physicalExam.id === index);

        if (~i) {
            state.prenatalConsultPhysicalExams.splice(i, 1);

            router.push({ name: 'prenatal-consultation-physicals-examinations', params:{consultation:response.data.consultation.slug} });

            Vue.swal(
                successMessage,
                '',
                'success'
            );
        }
    },
    deletePrenatalConsultationComplementarieExamHandler(state, { index, successMessage,response }) {

        let i = state.prenatalConsultComplementarieExams.findIndex(physicalExam => physicalExam.id === index);

        if (~i) {
            state.prenatalConsultComplementarieExams.splice(i, 1);

            router.push({ name: 'prenatal-consultation-complementaries-examinations', params:{consultation:response.data.consultation.slug} });

            Vue.swal(
                successMessage,
                '',
                'success'
            );
        }
    }

};

export default {
    state,
    getters,
    actions,
    mutations
}